var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreemium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 81,
    viewBox: "0 0 298 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.61 15.0481C370.056 16.6718 389.284 21.4643 389.284 21.4643L374.511 138.204L-18.3558 88.4907L-9.78353 20.747C20.1734 24.5378 49.0727 26.6659 77.9714 26.1706C104.234 25.7204 128.682 24.0026 153.553 21.8991C178.709 19.7716 202.665 16.5248 227.936 14.5247C252.56 12.5757 277.176 11.093 303.12 10.7488C321.411 10.5061 340.746 12.1159 359.61 15.0481Z",
    fill: "url(#paint0_linear_118_342)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7148,
    y: 53.8341,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.713,
    y: 6.83411,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FC7013"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.715,
    y: 17.8341,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#001837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_342",
    x1: 193.201,
    y1: -6.16798,
    x2: 167.529,
    y2: 196.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7013"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreemium);
export default __webpack_public_path__ + "static/media/freemium.8fd80cb7323eb9b22117636252963223.svg";
export { ForwardRef as ReactComponent };